import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_price_style.js";
//#region src/menu_price_style_helper.ts
var menu_price_style_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(priceStyle) {
	switch (priceStyle) {
		case 0: return "Default ($7, $7.50, $7.99)";
		case 1: return "One Digit ($7, $7.5, $7.99)";
		case 2: return "Two Digits ($7.00, $7.50, $7.99)";
	}
}
//#endregion
export { menu_price_style_helper_exports, name };

//# sourceMappingURL=menu_price_style_helper.js.map